export default __webpack_public_path__ + "static/chemical_reactions-afdd25b930704e2cf075b9aab94f9368.png";